import { NotificationsRepository } from '../domain/notifications.repository'
import { AvtGateway, HttpRequest } from '../avt.gateway'

export const odinNotificationsRepository: NotificationsRepository = {
  setMessagingToken: async (token: string): Promise<void> => {
    const request: HttpRequest = {
      method: 'POST',
      endpoint: `/odin/api/fcm-token`,
      body: {
        token
      }
    }

    try {
      await AvtGateway.executePostRequest(request)
    } catch (error) {
      console.error(error)
    }
  }
}
